Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "StatusIndicator2824253675",
  {"root":"StatusIndicator2824253675--root"},
  ".StatusIndicator2824253675--root{width:18px;height:18px;color:#ee5951}.StatusIndicator2824253675--root[data-statusindicator2824253675-status=warning]{color:#fdb10c}.StatusIndicator2824253675--root[data-statusindicator2824253675-status=warning] svg{margin:1px 0}",
  2,
  "StatusIndicator2824253675"
);
__webpack_require__.stylable.$.register(exports.default)
